import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { compact, toLower } from 'lodash';

import Definition from '../../../shared/Definition';

const formatBirthDate = utc => moment(utc).format('DDMMMYY');

const Age = ({ age, horseDateOfBirth, horseColourCode, horseSexCode, avgFlatWinDist }) => {
    const data = compact([
        horseDateOfBirth && formatBirthDate(horseDateOfBirth),
        toLower(horseColourCode),
        toLower(horseSexCode),
    ]).join(' ');
    return (
        <Definition term={age.replace(/-/g, '')}>
            { data && (
                <span className="hp-details__info">
                    ({data})
                </span>
            )}
            {avgFlatWinDist && (
                <span className="hp-details__info">
                    &nbsp;({avgFlatWinDist}f)
                </span>
            )}
        </Definition>
    );
};

Age.propTypes = {
    age: PropTypes.string,
    horseDateOfBirth: PropTypes.string,
    horseColourCode: PropTypes.string,
    horseSexCode: PropTypes.string,
    avgFlatWinDist: PropTypes.number,
};

export default Age;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Age.jsx